import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { DataProvider } from '../../providers/data/data';
import { HttpClient} from '@angular/common/http';
import { AdminRequestPage } from '../adminRequest/adminRequest';
import { DashboardPage } from '../dashboard/dashboard';


@IonicPage()
@Component({
  selector: 'page-adminDashboard',
  templateUrl: 'adminDashboard.html',
})
export class AdminDashboardPage {
  private userId: any;
  private date: any;
  private type: any;
  private companyId: any;
  private Dates = [];
  private GetUsersTimes = [];
  private undsen_day: any;
  private TimeCard = [];
  private dateBegin: any;
  private dateEnd: any;
  private countRequest = 0;
  private item: any;
  private today: any;
  private chuluuDate = '0';
  private amraltDate = '0';
  private amraltDateCount = 0;
  private chuluuDateCount = 0;
  private chuluuEndDate: any;
  private amralt: any;
  private chuluuList = [];
  private huselt = [];
  private datesClose = [];
  private datesChuluu = [];
  private dateVallBegin: any;
  private dateVallEnd: any;
  private startDate = "12-25";
  private endDate = "01-24";
  private nowDay: any;
  public notifs = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

  }

  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    if(parseInt(this.data.type) == 2 || parseInt(this.data.type) == 4) {
      document.getElementById('backmenu').style.display = 'block';
    } else {
      document.getElementById('backmenu').style.display = 'block';
    }
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Ажилчдын ирц бүртгэл';
  }

  ionViewDidLoad() {
    this.companyId = this.data.companyId;
    this.userId = this.data.userId;
    this.amralt = [];
    this.datesClose = [];
    this.datesChuluu = [];
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    let defYear = now.getFullYear();
    this.today = nowdate.substring(5,10);
    this.nowDay = nowdate;
    // console.log("today:"+ this.today + "/" + "nowDay" + this.nowDay);
    this.rest.Dates(this.companyId).subscribe(res => {
      this.Dates = res;
      for(let i = 0; i < this.Dates.length;i++) {
        if(this.Dates[i].begin_day <= nowdate && this.Dates[i].end_day >= nowdate) {
          this.date = this.Dates[i].id;
          this.dateVallBegin = this.Dates[i].begin_day.substring(5,10);
          this.dateVallEnd = this.Dates[i].end_day.substring(5,10);
          // console.log(this.dateVallBegin +':'+ this.dateVallEnd);
          this.rest.GetUsersTimes(this.data.companyId, this.date).subscribe(res => {
            this.GetUsersTimes = res;
            this.dateBegin = res.times[0].all_times[0].date;
            this.dateEnd = res.times[0].all_times[res.times[0].all_times.length - 1].date;
            for(let k=0;k<res.times.length;k++) {
              if(res.times[k].chuluu.length > 0) {
                for(let j=0;j<res.times[k].chuluu.length;j++) {
                  if(res.times[k].chuluu[j].forgot_date != res.times[k].chuluu[j].end_date){
                    let set = new Date(res.times[k].chuluu[j].end_date);
                    set.setDate(set.getDate()-1);
                    let set2 = set.getFullYear().toString() + '-' +
                    ('0' + (set.getMonth() + 1).toString()).slice(-2) + '-' +
                    ('0' + set.getDate().toString()).slice(-2);
                    this.chuluuList.push({id: k + '-' + j, val: set2});
                  } else {
                    this.chuluuList.push({id: k, val: 0});
                  }
                  // console.log(this.chuluuList);
                  for(let a=0;a<res.times[k].all_times.length;a++) {
                    if(res.times[k].user_id == res.times[k].chuluu[j].user_id
                      && res.times[k].all_times[a].startTime == null && res.times[k].all_times[a].endTime == null
                      && res.times[k].chuluu[j].is_solved == 1 && res.times[k].chuluu[j].holiday == 0) {
                      if(res.times[k].chuluu[j].forgot_date > res.times[k].all_times[a].date ||
                        res.times[k].all_times[a].date >= res.times[k].chuluu[j].end_date) {
                        let ccc = 0;
                        for(let ii=0;ii<this.datesClose.length;ii++) {
                          if(this.datesClose[ii].date == res.times[k].all_times[a].date && this.datesClose[ii].user_id == res.times[k].user_id) {
                            ccc++;
                          }
                        }
                        if(ccc == 0) {
                          this.datesClose.push({date: res.times[k].all_times[a].date, user_id: res.times[k].user_id});
                        }
                      }
                    }
                    if(res.times[k].user_id == res.times[k].chuluu[j].user_id
                      && res.times[k].all_times[a].startTime == null && res.times[k].all_times[a].endTime == null
                      && res.times[k].chuluu[j].is_solved == 1) {
                      if(res.times[k].all_times[a].date >= res.times[k].chuluu[j].forgot_date &&
                        res.times[k].all_times[a].date < res.times[k].chuluu[j].end_date) {
                        let ccc = 0;
                        for(let ii=0;ii<this.datesChuluu.length;ii++) {
                          if(this.datesChuluu[ii].date == res.times[k].all_times[a].date && this.datesChuluu[ii].user_id == res.times[k].user_id) {
                            ccc++;
                          }
                        }
                        if(ccc == 0) {
                          this.datesChuluu.push({date: res.times[k].all_times[a].date, user_id: res.times[k].user_id});
                        }
                      }
                    }
                    // console.log(this.datesClose);
                    // console.log(this.datesChuluu);
                    for(let ii=0;ii<this.datesClose.length;ii++) {
                      for(let jj=0;jj<this.datesChuluu.length;jj++) {
                        if(this.datesClose[ii].date == this.datesChuluu[jj].date && this.datesChuluu[jj].user_id == this.datesClose[ii].user_id) {
                          this.datesClose.splice(ii, 1);
                          // console.log(this.datesClose);
                        }
                      }
                    }
                  }
                }
              } else {
                this.chuluuList.push({id: k, val: 0});
              }
            }
          });
        }
      }

      this.rest.TimeCard(this.userId, this.date, this.companyId).subscribe(res => {
        this.TimeCard = res;
        // for(let i = 0; i < res.time_types.length; i++){
          this.rest.GetRequest(this.data.userId, this.date, "1").subscribe(res => {
            this.huselt = res.huselt;
            for(let i = 0; i < this.huselt.length; i++){
              if(this.huselt[i].is_solved == 0){
                this.countRequest = this.countRequest + res.huselt.length;
              }
            }
            this.rest.GetRequest(this.data.userId, this.date, "2").subscribe(res => {
              this.huselt = res.huselt;
              for(let i = 0; i < this.huselt.length; i++){
                if(this.huselt[i].is_solved == 0){
                  this.countRequest = this.countRequest + res.huselt.length;
                }
              }
              this.rest.GetRequest(this.data.userId, this.date, "3").subscribe(res => {
                this.huselt = res.huselt;
                for(let i = 0; i < this.huselt.length; i++){
                  if(this.huselt[i].is_solved == 0){
                    this.countRequest = this.countRequest + res.huselt.length;
                  }
                }
                this.rest.GetRequest(this.data.userId, this.date, "4").subscribe(res => {
                  this.huselt = res.huselt;
                  for(let i = 0; i < this.huselt.length; i++){
                    if(this.huselt[i].is_solved == 0){
                      this.countRequest = this.countRequest + res.huselt.length;
                    }
                  }
                });
              });
            });
          });
        // }

      });
      this.getUserNotifs();
    });
  }

  getUserNotifs() {
    this.rest.getNotifUsersDate().subscribe(res => {
      this.notifs = res;
      if(this.notifs.length > 0) {
        this.showToast('АЖИЛТНУУДЫН 3 САРЫН ХУГАЦАА ДУУСАХ ДӨХӨЖ БАЙНА!');
      }
    });
  }

  userNotifs() {
    let str = '';
    for(let i = 0; i < this.notifs.length; i++) {
      str = str + this.notifs[i].firstname + '<br>';
    }
    this.showAlert(str);
  }

  showAlert(err) {
    let alert = this.alertCtrl.create({
      title: "АЖИЛТНУУДЫН 3 САРЫН ХУГАЦАА ДУУСАХ ДӨХӨЖ БАЙНА!",
      subTitle: err,
      buttons: ["OK"]
    });
    alert.present();
  }

  dash(item: any){
    this.navCtrl.push(DashboardPage, { item: item });
  }

  getTimeCard() {
    this.datesClose = [];
    this.datesChuluu = [];
    this.chuluuList = [];
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    let defYear = now.getFullYear();
    this.today = nowdate.substring(5,10);
    this.nowDay = nowdate;
    this.rest.GetUsersTimes(this.data.companyId, this.date).subscribe(res => {
      this.GetUsersTimes = res;
      this.dateBegin = res.times[0].all_times[0].date;
      this.dateEnd = res.times[0].all_times[res.times[0].all_times.length - 1].date;
      this.dateVallBegin = this.dateBegin.substring(5,10);
      this.dateVallEnd = this.dateEnd.substring(5,10);
      // console.log(this.dateVallBegin +':'+ this.dateVallEnd);
      // console.log(this.nowDay + "////" + this.dateBegin);
      for(let k=0;k<res.times.length;k++) {
        if(res.times[k].chuluu.length > 0) {
          for(let j=0;j<res.times[k].chuluu.length;j++) {
              if(res.times[k].chuluu[j].forgot_date != res.times[k].chuluu[j].end_date){
                let set = new Date(res.times[k].chuluu[j].end_date);
                set.setDate(set.getDate()-1);
                let set2 = set.getFullYear().toString() + '-' +
                ('0' + (set.getMonth() + 1).toString()).slice(-2) + '-' +
                ('0' + set.getDate().toString()).slice(-2);
                this.chuluuList.push({id: k + '-' + j, val: set2});
              } else {
                this.chuluuList.push({id: k, val: 0});
              }
              for(let a=0;a<res.times[k].all_times.length;a++) {
                if(res.times[k].user_id == res.times[k].chuluu[j].user_id &&
                  (res.times[k].chuluu[j].forgot_date > res.times[k].all_times[a].date ||
                  res.times[k].all_times[a].date >= res.times[k].chuluu[j].end_date)
                  && res.times[k].all_times[a].startTime == null && res.times[k].all_times[a].endTime == null) {
                  let ccc = 0;
                  for(let ii=0;ii<this.datesClose.length;ii++) {
                    if(this.datesClose[ii].date == res.times[k].all_times[a].date && this.datesClose[ii].user_id == res.times[k].user_id) {
                      ccc++;
                    }
                  }
                  if(ccc == 0) {
                    this.datesClose.push({date: res.times[k].all_times[a].date, user_id: res.times[k].user_id});
                  }
                }
                if(res.times[k].user_id == res.times[k].chuluu[j].user_id
                  && res.times[k].all_times[a].startTime == null && res.times[k].all_times[a].endTime == null
                  && res.times[k].chuluu[j].is_solved == 1) {
                  if(res.times[k].all_times[a].date >= res.times[k].chuluu[j].forgot_date &&
                    res.times[k].all_times[a].date < res.times[k].chuluu[j].end_date) {
                    let ccc = 0;
                    for(let ii=0;ii<this.datesChuluu.length;ii++) {
                      if(this.datesChuluu[ii].date == res.times[k].all_times[a].date && this.datesChuluu[ii].user_id == res.times[k].user_id) {
                        ccc++;
                      }
                    }
                    if(ccc == 0) {
                      this.datesChuluu.push({date: res.times[k].all_times[a].date, user_id: res.times[k].user_id});
                    }
                  }
                }
                // unaj bgaa heseg dateClose dotor ireh estoi amraltiin odor ireeguigees uidsen uchir ni dateChuluu dotor ug amrlatiin odor ni
                // orson amraltiin odriig oroltsuulj chuluu avsan
                for(let i1=0;i1<this.datesClose.length;i1++) {
                  for(let j1=0;j1<this.datesChuluu.length;j1++) {
                    if(this.datesClose[i1].date == this.datesChuluu[j1].date && this.datesChuluu[j1].user_id == this.datesClose[i1].user_id) {
                      this.datesClose.splice(i1, 1);
                    }
                  }
                }
              }
            }
        } else {
          this.chuluuList.push({id: k, val: 0});
        }
      }
    });
  }

  setTimeVerifyAdmin(userId: any, undsen_day: any, work_day: any, core_day: any, undsen_time: any, work_time: any){
    this.rest.AdminAgree(userId, this.date, undsen_day, work_day, core_day, undsen_time, work_time).subscribe(res => {
      if(res == null) {
        this.showToast1('Сар дуусаагүй байна!!!');
      } else if(res.msg == 'ok') {
        this.showToast('Амжилттай баталгаажууллаа.');
      } else {
        this.showToast1('Сар дуусаагүй байна!!!');
      }
      this.getTimeCard();
  });
}

  onSelectClicked(value) {
    setTimeout(() => {
      document.getElementsByClassName('alert-radio-group')[0]
              .querySelector('[aria-checked="true"]')
              .scrollIntoView();
    }, 500);
  }

  request_sent(){
    this.navCtrl.push(AdminRequestPage);
  }

  sentReguest(){
    this.navCtrl.push(AdminRequestPage);
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/adminDashboard/adminDashboard.ts